import { Input } from '@domgen/base-design-system-2.0/atoms/Input';
import { CircleCheck } from '../../../assets/icons/CircleCheck';
import { usProvinces } from '../constants/usProvinces';
import { FormChangeEvent } from '../../../hooks/useFormValidation';
import { FormKey } from '../../../enums/formKey';
import { StepKey } from '../../../enums/stepKey';
import { Select } from '@domgen/base-design-system-2.0/atoms/Select';
import { ApplianceFormData } from '../../../models/form/appliance';
import { AutoComplete } from '@domgen/shared/enums/autoComplete';
import { useTranslation } from 'react-i18next';

type ManualMerchandiseLocationFormProps = {
  formValues: Partial<ApplianceFormData[StepKey.PERSONAL_DETAILS]>;
  errors: Record<string, string>;
  handleChange: (e: FormChangeEvent) => string | void;
  onBlur: (e: FormChangeEvent) => string | void;
};

export const ManualMerchandiseLocationForm = ({
  formValues,
  errors,
  handleChange,
  onBlur,
}: ManualMerchandiseLocationFormProps) => {
  const { t } = useTranslation('personalDetailsPage', { keyPrefix: 'addressForm' });

  return (
    <>
      <div className="col-span-8">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] as string) ?? ''}
          label={t('line1Label')}
          placeholder={t('line1Placeholder')}
          name={FormKey.MERCHANDISE_ADDRESS_LINE_1}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] &&
            !errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] ? (
              <CircleCheck />
            ) : undefined
          }
          hasError={errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_1]}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] !== '' &&
            !errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_1]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_SUB_BUILDING] as string) ?? ''}
          label={t('line2Label')}
          placeholder={t('line2Placeholder')}
          name={FormKey.MERCHANDISE_SUB_BUILDING}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_SUB_BUILDING] &&
            !errors?.[FormKey.MERCHANDISE_SUB_BUILDING] ? (
              <CircleCheck />
            ) : undefined
          }
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_SUB_BUILDING] !== '' &&
            !errors?.[FormKey.MERCHANDISE_SUB_BUILDING]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8">
        <Select
          label={t('stateLabel')}
          placeholder={t('statePlaceholder')}
          name={FormKey.MERCHANDISE_STATE_CODE}
          id={FormKey.MERCHANDISE_STATE_CODE}
          hasError={errors[FormKey.MERCHANDISE_STATE_CODE]}
          options={usProvinces}
          value={(formValues?.[FormKey.MERCHANDISE_STATE_CODE] as string) ?? ''}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_STATE_CODE] !== '' &&
            !errors[FormKey.MERCHANDISE_STATE_CODE]
          }
          onChange={(value: string) =>
            handleChange({
              target: { name: FormKey.MERCHANDISE_STATE_CODE, value },
            } as FormChangeEvent)
          }
          onBlur={(value: string) =>
            onBlur({
              target: {
                name: FormKey.MERCHANDISE_STATE_CODE,
                value,
              },
            } as FormChangeEvent)
          }
          maxHeight={320}
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8 md:col-span-4">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_CITY] as string) ?? ''}
          label={t('cityLabel')}
          placeholder={t('cityPlaceholder')}
          name={FormKey.MERCHANDISE_CITY}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_CITY] && !errors?.[FormKey.MERCHANDISE_CITY] ? (
              <CircleCheck />
            ) : undefined
          }
          hasError={errors?.[FormKey.MERCHANDISE_CITY]}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_CITY] !== '' && !errors?.[FormKey.MERCHANDISE_CITY]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8 md:col-span-4">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_POSTAL_CODE] as string) ?? ''}
          label={t('zipCodeLabel')}
          placeholder={t('zipCodePlaceholder')}
          name={FormKey.MERCHANDISE_POSTAL_CODE}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_POSTAL_CODE] &&
            !errors?.[FormKey.MERCHANDISE_POSTAL_CODE] ? (
              <CircleCheck />
            ) : undefined
          }
          hasError={errors?.[FormKey.MERCHANDISE_POSTAL_CODE]}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_POSTAL_CODE] !== '' &&
            !errors?.[FormKey.MERCHANDISE_POSTAL_CODE]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
    </>
  );
};
